import React, { Component } from 'react';
import { fonts } from '@peachjar/components';
import { css } from 'react-emotion';

const styles = {
  container: css({
    fontFamily: fonts.ProximaNovaA,
    paddingTop: '1.5rem',
    paddingBottom: '1rem',
  }),
  success: css({
    fontSize: '1.1rem',
    paddingBottom: '0.3rem',
  }),
  details: css({
    fontSize: '0.8rem',
  }),
  closeBrowserNote: css({
    fontSize: '0.8rem',
    paddingTop: '2rem',
  }),
};

const SuccessMessage = ({ task, status, isAssigneePresent }) => (
  <div className={styles.container}>
    <div className={styles.success}>
      Success! {task} is {status}.
    </div>
    <div className={styles.details}>You will receive a confirmation email.</div>

    {isAssigneePresent && (
      <div className={styles.closeBrowserNote}>
        You may now close this browser window.
      </div>
    )}
  </div>
);

export default SuccessMessage;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/SuccessMessage.jsx